module.exports = __webpack_public_path__ + "img/banner2.d1d6230e.png";